import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import DefaultContainer from "shared/components/DefaultContainer"
import SpinnerLoad from "../SpinnerLoad"

import styles from "./styles.css"

import iconProcessing from "../../../../assets/svg/fixed_voice_dash_loading.svg"
import iconReschedule from "../../../../assets/svg/fixed_voice_dash_reschedule.svg"
import iconSuspended from "../../../../assets/svg/fixed_voice_dash_suspended.svg"

const GeneralViewOrders = ({
  loading,
  activeNumbers,
  inProgressNumbers,
  inactiveNumbers
}) => {
  if (loading) {
    return (
      <div className={styles.loading_dash}>
        <SpinnerLoad />
      </div>
    )
  }

  return (
    <DefaultContainer customClass={styles.containerClass}>
      <table className={styles.container_general_order}>
        <thead>
          <tr>
            <th className={styles.title}>Visão geral dos meus pedidos</th>
            <th>Números</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={styles.title_line}>
              <img src={iconProcessing} alt="loading orders icon" />
              Ativo
            </td>
            <td>{activeNumbers}</td>
          </tr>

          <tr>
            <td className={styles.title_line}>
              <img src={iconReschedule} alt="reschedule orders icon" />
              Aguardando ativação
            </td>
            <td>{inProgressNumbers}</td>
          </tr>
          <tr>
            <td className={styles.title_line}>
              <img src={iconSuspended} alt="suspenso icon" />
              Cancelado
            </td>
            <td>{inactiveNumbers}</td>
          </tr>
        </tbody>
      </table>
    </DefaultContainer>
  )
}

GeneralViewOrders.propTypes = {
  loading: PropTypes.bool,
  activeNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inProgressNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inactiveNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

const mapStateToProps = ({ customersFixedVoice }) => ({
  loading: customersFixedVoice.loading,
  activeNumbers: customersFixedVoice.activeNumbers,
  inProgressNumbers: customersFixedVoice.inProgressNumbers,
  inactiveNumbers: customersFixedVoice.inactiveNumbers
})

export default connect(mapStateToProps, null)(GeneralViewOrders)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/GeneralViewOrders/index.js